import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from './navigation/NavMenu';

export default props => (
  <Grid fluid>
    <Row>
      <Col className="navMenuContainer">
        <NavMenu />
      </Col>
      <Col className="mainLayout">
        {props.children}
      </Col>
    </Row>
  </Grid>
);


// WEBPACK FOOTER //
// ./src/components/Layout.js